import { createStore } from 'vuex';
import apiPlugin from './plugins/api';
import $modules from './modules';
import $constants from '../const';

export const store = createStore({
    plugins: [
        apiPlugin,
    ],
    modules: {
        chat: $modules.chat,
        publisher: $modules.publisher,
        support: $modules.support,
    },
    state: {
        currentView: $constants.APP_VIEW__START_CHAT,
        appLoadingCounter: 0,
        error: {
            show: false,
            title: "",
            message: "",
        },
    },
    actions: {
        setView({ commit }, view) {
            commit('SET_CURRENT_VIEW', view)
        },
        showError({ commit },{ message, title }) {
            commit('SET_ERROR', { show: true, title: title, message: message });
        },
        clearError({ commit }) {
            commit('SET_ERROR', { show: false, title: '', message: '' });
        },
        incrementAppLoader({ commit }) {
            commit('INCREMENT_APP_LOADER');
        },
        decrementAppLoader({ commit }) {
            commit('DECREMENT_APP_LOADER');
        },
        async resetApp({ dispatch }) {  
            dispatch('incrementAppLoader');

            await dispatch('clearError');
            await dispatch('setView', $constants.APP_VIEW__START_CHAT);

            dispatch('decrementAppLoader');
        }
    },
    mutations: {
        SET_CURRENT_VIEW(state, value) {
            state.currentView = value;
        },
        SET_ERROR(state, value) {
            state.error = value;
        },
        INCREMENT_APP_LOADER(state) {
            state.appLoadingCounter++;
        },
        DECREMENT_APP_LOADER(state) {
            state.appLoadingCounter--;
        },

    },
    getters: {
        view: state => state.currentView,
        error: state => state.error,
        appLoading: state => state.appLoadingCounter > 0,
    }
})